import { confirmToast } from "../../utils/toast";
import React, { useState, useEffect } from "react";
import axios from "../../utils/axiosConfig";

const ContactGroupMaster = () => {

  const [form, setForm] = useState({ GroupDesc: "" });
  const [editingId, setEditingId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [activeTab, setActiveTab] = useState("list");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = async () => {
    const res = await axios.get("/contact-groups");
    setGroups(res.data);
  };

  const handleChange = (e) => {
    setForm({ GroupDesc: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await axios.put(`${"/contact-groups"}/${editingId}`, form);
      } else {
        await axios.post("/contact-groups", form);
      }

      alert(editingId ? "Contact group updated successfully" : "Contact group saved successfully");
      fetchGroups();
      resetForm();
      setActiveTab("list");
    } catch (err) {
      alert(err.response?.data?.message || "Error saving contact group");
    }
  };

  const handleEdit = (group) => {
    setForm({ GroupDesc: group.GroupDesc });
    setEditingId(group.GroupId);
    setActiveTab("form");
  };

  const handleDelete = async (id) => {
    if (!await confirmToast("Delete this group?")) return;
    await axios.delete(`${"/contact-groups"}/${id}`);
    fetchGroups();
  };

  const resetForm = () => {
    setForm({ GroupDesc: "" });
    setEditingId(null);
  };

  // Pagination logic
  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = groups.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(groups.length / recordsPerPage);

  return (
    <div className="container-fluid">

      <h4 className="mb-3 fw-bold">Contact Group Master</h4>

      <div className="card shadow-sm border-0">

        {/* Tabs */}
        <div className="card-header bg-white">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "list" ? "active" : ""}`}
                onClick={() => setActiveTab("list")}
              >
                Group List
              </button>
            </li>

            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "form" ? "active" : ""}`}
                onClick={() => setActiveTab("form")}
              >
                {editingId ? "Edit Group" : "Add Group"}
              </button>
            </li>
          </ul>
        </div>

        <div className="card-body">

          {/* ================= FORM ================= */}
          {activeTab === "form" && (
            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Group Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    name="GroupDesc"
                    value={form.GroupDesc}
                    onChange={handleChange}
                    placeholder="Enter Group Name"
                    required
                  />
                </div>

              </div>

              <div className="mt-4">
                <button type="submit" className="btn btn-success me-2">
                  {editingId ? "Update" : "Save"}
                </button>

                {editingId && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </form>
          )}

          {/* ================= LIST ================= */}
          {activeTab === "list" && (
            <>
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-light">
                    <tr>
                      <th>Group ID</th>
                      <th>Group Name</th>
                      <th>Created At</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentRecords.map((g) => (
                      <tr key={g.GroupId}>
                        <td>{g.GroupId}</td>
                        <td>{g.GroupDesc}</td>
                        <td>{new Date(g.CreatedAt).toLocaleString()}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary me-2"
                            onClick={() => handleEdit(g)}
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(g.GroupId)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <nav>
                <ul className="pagination justify-content-end">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default ContactGroupMaster;
